import type { FC } from "react";

import { useDesktop } from "@/hooks/use-desktop";

export const DesktopTrafficLights: FC = () => {
    const { isDesktop, isFullscreen } = useDesktop();
    if (!isDesktop || isFullscreen) {
        return null;
    }

    // we leave the actual rendering of the traffic lights to the system, but we reserve space for them
    return <div className="h-3 w-[3.25rem]" />;
};
